export class Expevisit {
    private expeditionId: string;
    private visit: number;

    constructor( expeditionId: string, visit: number ) {
        this.expeditionId = expeditionId;
        this.visit = visit;
    }

    public setExpeditionId (expeditionId: string) { this.expeditionId = expeditionId; }
    public getExpeditionId () { return this.expeditionId; }

    public setVisit (visit: number) { this.visit = visit; }
    public getVisit () { return this.visit; }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/Expevisit.component.ts